module.exports = __webpack_public_path__ + "static/img/6-1.8a61c0db.jpg";